/**
 * A utility class mainly used to retrieve properties from the GraphQL response
 * for a brand.
 */
export class BrandUtil {

    /**
     * Retrieves the brand's ID.
     * 
     * @param { object } brandData - The data to read.
     * @returns { string }
     */
    static getId( brandData ) {
        return brandData?.node?.id;
    }

    /**
     * Retrieves the brand's name.
     * 
     * @param { object } brandData - The data to read.
     * @returns { string }
     */
    static getName( brandData ) {
        return brandData?.node?.name;
    }

    /**
     * Retrieves the brand's segment ID. This value is a Roster Group ID that is being
     * used to collect all users for this particular brand.
     * 
     * @param { object } brandData - The data to read.
     * @returns { string }
     */
    static getSegmentId( brandData ) {
        return brandData?.node?.segmentId;
    }

}
